window.Shopify.loadFeatures(
 [
   {
     name: 'consent-tracking-api',
     version: '0.1',
   },
 ],
 error => {
   if (error) {
     // Rescue error
   }
   // If error is false, the API has loaded and ready to use!

   updateConsentStatus();

   const cookieId = window.Shopify.customerPrivacy.consentId();
   
    let consentIdElement = document.getElementById("CookieDeclarationUserStatusLabelConsentId");
    if(consentIdElement){
      consentIdElement.innerHTML = cookieId;
    }   
    updateConsentStatus();
    document.addEventListener("trackingConsentAccepted", function () {
      updateConsentStatus();
  });

  function updateConsentStatus(){
    const preferencesCookieState = window.Shopify.customerPrivacy.preferencesProcessingAllowed();
    const analyticsCookieState = window.Shopify.customerPrivacy.analyticsProcessingAllowed();
    const marketingCookieState = window.Shopify.customerPrivacy.marketingAllowed();

    let currentState = "Deny all";

    if(preferencesCookieState && analyticsCookieState && marketingCookieState){
      currentState = "Allow all";
    }
    else if(!preferencesCookieState && !analyticsCookieState && !marketingCookieState){
      currentState = "Deny all";
    }
    else{
      preferencesCookieState ? currentState = "<br>Prefrence cookies allowed" : currentState = "<br>Prefrence cookies denied";
      analyticsCookieState ? currentState += "<br>Analytics cookies allowed" : currentState += "<br>Analytics cookies denied";
      marketingCookieState ? currentState += "<br>Marketing cookies allowed" : currentState += "<br>Marketing cookies denied";
    }

    let ad_user_data = "denied";
    let ad_personalization = "denied";
    let ad_storage = "denied";
    let analytics_storage = "denied";

    if(marketingCookieState){

      ad_user_data = 'granted';
      ad_personalization = 'granted';
      ad_storage = 'granted';
    }
    if(analyticsCookieState){
      analytics_storage = 'granted';
    }


    gtag('consent', 'update', {
      'ad_storage': ad_storage,
      'ad_user_data': ad_user_data,
      'ad_personalization': ad_personalization,
      'analytics_storage': analytics_storage
    });

    gtag('consent', 'default', {
      'ad_storage': "denied",
      'ad_user_data': "denied",
      'ad_personalization': "denied",
      'analytics_storage': "denied"
    });

   let cookieDelecrationStatusElement =  document.getElementById("CookieDeclarationUserStatus");
   if(cookieDelecrationStatusElement){
    cookieDelecrationStatusElement.innerHTML = currentState;
   }
   
  }
 }, 
);